import './App.css';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import SurveyComponent from './components/SurveyComponent';


function App() {
  return (
    <Router>
      <Routes>
    <Route path="/" element={< SurveyComponent />} />
    </Routes>
    </Router>
  );
}

export default App;
